module.exports = __webpack_public_path__ + "img/report-sample-04@3x.5bf158f4.png";